import type { ItemRow } from '~~/shared/items/itemRow'

/**
 * The confirmation text for a MULTI-select delete (MAR-459).
 *
 * The single-item path opens `DeleteDocumentDialog`, which names the expedientes and counts a
 * folder's subtree. A bulk delete stays an inline `confirm()` — N rows means N reference sets, and
 * listing them all would be a wall rather than a check — but the count it shows is the number of
 * SELECTED ROWS, and a folder in that selection quietly takes its whole subtree with it
 * (`services/items/trash.ts` moves the folder plus every descendant). So a selection containing a
 * folder gets the wording that says so, and stops calling folders "documents".
 *
 * Shared by the two browsers, `pages/app/docs/index.vue` (Biblioteca) and
 * `components/documents/FileExplorer.vue` (case-scoped), which duplicate this UI — mirroring the
 * check by hand is exactly how MAR-459 happened.
 */
export function deleteConfirmKey(items: Array<Pick<ItemRow, 'type'>>): string {
  return items.some(item => item.type === 'folder')
    ? 'documents.deleteConfirmWithFolders'
    : 'documents.deleteConfirm'
}
